import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import GroupsPage from './pages/GroupsPage';
import WorkshopsPage from './pages/WorkshopsPage';
import PersonalPage from './pages/PersonalPage';
import TestimonialsPage from './pages/TestimonialsPage';
import CustomOrderPage from './pages/CustomOrderPage';
import ContactPage from './pages/ContactPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/groups" element={<GroupsPage />} />
          <Route path="/workshops" element={<WorkshopsPage />} />
          <Route path="/personal" element={<PersonalPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/custom-order" element={<CustomOrderPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

